import { render, staticRenderFns } from "./AppUpdateBanner.vue?vue&type=template&id=60aac95b&scoped=true&"
import script from "./AppUpdateBanner.vue?vue&type=script&lang=js&"
export * from "./AppUpdateBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aac95b",
  null
  
)

export default component.exports